/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    CardTypeConsentEntity,
    CardTypeConsentEntityFromJSON,
    CardTypeConsentEntityFromJSONTyped,
    CardTypeConsentEntityToJSON,
} from './CardTypeConsentEntity';

/**
 * 
 * @export
 * @interface ConsentEntity
 */
export interface ConsentEntity {
    /**
     * 
     * @type {string}
     * @memberof ConsentEntity
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof ConsentEntity
     */
    hsaId?: string;
    /**
     * 
     * @type {boolean}
     * @memberof ConsentEntity
     */
    optIn?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ConsentEntity
     */
    optOut?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ConsentEntity
     */
    readConsent?: boolean;
    /**
     * 
     * @type {CardTypeConsentEntity}
     * @memberof ConsentEntity
     */
    cardTypeConsent?: CardTypeConsentEntity;
}

export function ConsentEntityFromJSON(json: any): ConsentEntity {
    return ConsentEntityFromJSONTyped(json, false);
}

export function ConsentEntityFromJSONTyped(json: any, ignoreDiscriminator: boolean): ConsentEntity {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'hsaId': !exists(json, 'hsaId') ? undefined : json['hsaId'],
        'optIn': !exists(json, 'optIn') ? undefined : json['optIn'],
        'optOut': !exists(json, 'optOut') ? undefined : json['optOut'],
        'readConsent': !exists(json, 'readConsent') ? undefined : json['readConsent'],
        'cardTypeConsent': !exists(json, 'cardTypeConsent') ? undefined : CardTypeConsentEntityFromJSON(json['cardTypeConsent']),
    };
}

export function ConsentEntityToJSON(value?: ConsentEntity | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'hsaId': value.hsaId,
        'optIn': value.optIn,
        'optOut': value.optOut,
        'readConsent': value.readConsent,
        'cardTypeConsent': CardTypeConsentEntityToJSON(value.cardTypeConsent),
    };
}

